import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5050/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Companies API
export const companiesAPI = {
  getAll: (params) => api.get('/companies', { params }),
  getById: (id) => api.get(`/companies/${id}`),
  create: (data) => api.post('/companies', data),
  update: (id, data) => api.put(`/companies/${id}`, data),
  delete: (id) => api.delete(`/companies/${id}`),
  search: (query) => api.get(`/companies/search?q=${query}`),
};

// Parties API
export const partiesAPI = {
  getAll: (params) => api.get('/parties', { params }),
  getById: (id) => api.get(`/parties/${id}`),
  create: (data) => api.post('/parties', data),
  update: (id, data) => api.put(`/parties/${id}`, data),
  delete: (id) => api.delete(`/parties/${id}`),
  search: (query) => api.get(`/parties/search?q=${query}`),
};

// Bills API
export const billsAPI = {
  getAll: (params) => api.get('/bills', { params }),
  getById: (id) => api.get(`/bills/${id}`),
  create: (data) => api.post('/bills', data),
  update: (id, data) => api.put(`/bills/${id}`, data),
  delete: (id) => api.delete(`/bills/${id}`),
  search: (params) => api.get('/bills/search', { params }),
  // Bills are addressed by id, not by number: a bill number is reused in a new financial year,
  // so a number would resolve to two different invoices.
  getPendingAmount: (billId) => api.get('/bills/pending', { params: { billId } }),
  getBulkPendingAmounts: (billIds) => api.get('/bills/pending/bulk', { params: { billIds: Array.isArray(billIds) ? billIds.join(',') : billIds } }),
};

// Payments API
export const paymentsAPI = {
  getAll: (params) => api.get('/payments', { params }),
  getById: (id) => api.get(`/payments/${id}`),
  create: (data) => api.post('/payments', data),
  createBulk: (data) => api.post('/payments/bulk', data),
  update: (id, data) => api.put(`/payments/${id}`, data),
  delete: (id) => api.delete(`/payments/${id}`),
  search: (params) => api.get('/payments/search', { params }),
};

// Reports API
export const reportsAPI = {
  getFinancialYears: () => api.get('/reports/financial-years'),
  getPendingAmounts: (params) => api.get('/reports/pending', { params }),
  getSummary: (params) => api.get('/reports/summary', { params }),
  getCompanyBreakdown: (params) => api.get('/reports/company-breakdown', { params }),
  getPartyBreakdown: (params) => api.get('/reports/party-breakdown', { params }),
  downloadCompanyPDF: (companyId, params) => api.get(`/reports/download/company/${companyId}`, { 
    params, 
    responseType: 'blob' 
  }),
  downloadPartyPDF: (partyId, params) => api.get(`/reports/download/party/${partyId}`, { 
    params, 
    responseType: 'blob' 
  }),
};

export default api;
